import { type ReactNode, createContext, useContext, useEffect, useState } from 'react';

import { DEFAULT_PAGE_TITLE } from '../brand';

interface TitleContextType {
  title: string;
  setTitle: (title: string) => void;
}

const TitleContext = createContext<TitleContextType | undefined>(undefined);

export function TitleProvider({ children }: { children: ReactNode }) {
  const [title, setTitle] = useState(DEFAULT_PAGE_TITLE);

  useEffect(() => {
    document.title = title;
  }, [title]);

  return <TitleContext.Provider value={{ title, setTitle }}>{children}</TitleContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export function useTitle() {
  const context = useContext(TitleContext);
  if (context === undefined) {
    throw new Error('useTitle must be used within a TitleProvider');
  }
  return context;
}
